function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
export default function buildTableOfContents(sections = []) {
    const toc = [];
    const stack = [
        {
            level: 0,
            sections: toc
        }
    ];
    sections.forEach((section)=>{
        const { id = "", level, tocSkip = false, visible = true } = section;
        // Skip if NOT visible
        if (!visible) return;
        // Skip table of contents or if specified
        if (id.includes("toc") || tocSkip) return;
        // Find the correct parent section to add the current section to
        while(stack.length > 0 && stack[stack.length - 1].level >= level){
            stack.pop();
        }
        const parent = stack[stack.length - 1];
        const newSection = _object_spread_props(_object_spread({}, section), {
            sections: []
        });
        parent.sections.push(newSection);
        // Push the current section onto the stack
        stack.push(newSection);
    });
    return toc;
}
